import cn from 'clsx';
import PropTypes from 'prop-types';
import styles from './modal.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ModalFooter({
  children,
  className,
  ...restProps
}) {
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.footer, className),
    ...restProps,
    children: children
  });
}
ModalFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};